import { useUIColors } from "@/core/hooks";
import { useI18nContext } from "@/core/providers/I18nProvider";

import React from "react";
import Svg, { Path } from "react-native-svg";

export function BackArrowIcon({
  size = 24,
  color,
}: {
  size?: number;
  color?: string;
}) {
  const c = useUIColors();
  const { isRTL } = useI18nContext();
  const iconColor = color || c.fontPrimary;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="8 0 14 24"
      fill="none"
      style={{
        transform: [{ scaleX: isRTL ? -1 : 1 }],
      }}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
        fill={iconColor}
      />
    </Svg>
  );
}

export default BackArrowIcon;
